import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TimerService } from './timerService.service';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss']
})
export class TimerComponent implements OnInit,OnDestroy {
  minutes = "00";
  seconds = "00";
  secondsSub: Subscription;
  minutesSub: Subscription;
  constructor(private timerService: TimerService) { }

  ngOnInit(): void {
    this.secondsSub = this.timerService.seconds.subscribe(seconds => {      
      this.seconds = seconds < 10 ? "0" + seconds.toString() : seconds.toString();
    });
    this.minutesSub = this.timerService.minutes.subscribe(minutes => {
      this.minutes = minutes < 10 ? "0" + minutes.toString() : minutes.toString();
    });
  }

  ngOnDestroy() {
    this.secondsSub.unsubscribe();
    this.minutesSub.unsubscribe();
  }
}
